export enum enumDataBaseCollections {
    brandData = 'brandData_connect',
}